import './index.css';
import { SkeletonHtml } from './skeleton';

const GLOBAL_NAME = 'voiceover-demo';

let mounted = false;
let currentContainer: Element | null = null;
let cleanupFn: (() => void) | null = null;

async function mount(targetId?: string) {
  if (mounted) return;

  const container = targetId
    ? document.getElementById(targetId)
    : document.querySelector(`[data-component="${GLOBAL_NAME}"]`);

  if (!container) {
    console.error(`[${GLOBAL_NAME}] Container not found`);
    return;
  }

  currentContainer = container;
  container.id = GLOBAL_NAME;

  const skeletonLoader = document.createElement('div');
  skeletonLoader.id = 'skeleton-loader';
  skeletonLoader.style.textAlign = 'center';
  skeletonLoader.innerHTML = SkeletonHtml;
  container.appendChild(skeletonLoader);

  const { mountApp } = await import('./main');
  skeletonLoader.remove();
  cleanupFn = mountApp(container) as unknown as (() => void) | null;
  mounted = true;
}

function unmount() {
  if (!mounted || !currentContainer) return;
  if (cleanupFn) {
    cleanupFn();
    cleanupFn = null;
  }

  currentContainer.innerHTML = '';
  mounted = false;
  currentContainer = null;
}

declare global {
  interface Window {
    [GLOBAL_NAME]: {
      mount: (targetId?: string) => Promise<void>;
      unmount: () => void;
    };
  }
}

window[GLOBAL_NAME] = { mount, unmount };

window.dispatchEvent(new CustomEvent(`${GLOBAL_NAME}:ready`));
